/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Pagination_Rowsperpage2Inputs */

const id_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baris per halaman`)
};

const ms_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baris setiap halaman`)
};

const da_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rækker pr. side`)
};

const de_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeilen pro Seite`)
};

const en_us2_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows per page`)
};

const es_es2_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas por página`)
};

const es_mx2_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas por página`)
};

const fil_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows bawat pahina`)
};

const fr_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lignes par page`)
};

const it_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Righe per pagina`)
};

const hu_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorok oldalanként`)
};

const nl_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rijen per pagina`)
};

const no_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rader per side`)
};

const pl_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wierszy na stronę`)
};

const pt_br2_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows per page`)
};

const pt_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas por página`)
};

const ro_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rânduri pe pagină`)
};

const fi_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivejä per sivu`)
};

const sv_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rader per sida`)
};

const vi_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số hàng mỗi trang`)
};

const tr_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayfa başına satır`)
};

const cs_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Řádků na stránku`)
};

const bg_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редове на страница`)
};

const ru_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Строк на странице`)
};

const uk_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рядків на сторінку`)
};

const ar_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صف لكل صفحة`)
};

const hi_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति पृष्ठ पंक्तियाँ`)
};

const th_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แถวต่อหน้า`)
};

const ja_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示行数`)
};

const zh_cn2_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows per page`)
};

const zh_hant1_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows per page`)
};

const ko_table_pagination_rowsperpage2 = /** @type {(inputs: Table_Pagination_Rowsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows per page`)
};

/**
* | output |
* | --- |
* | "Rows per page" |
*
* @param {Table_Pagination_Rowsperpage2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_pagination_rowsperpage2 = /** @type {((inputs?: Table_Pagination_Rowsperpage2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Pagination_Rowsperpage2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_pagination_rowsperpage2(inputs)
	if (locale === "ms") return ms_table_pagination_rowsperpage2(inputs)
	if (locale === "da") return da_table_pagination_rowsperpage2(inputs)
	if (locale === "de") return de_table_pagination_rowsperpage2(inputs)
	if (locale === "en-US") return en_us2_table_pagination_rowsperpage2(inputs)
	if (locale === "es-ES") return es_es2_table_pagination_rowsperpage2(inputs)
	if (locale === "es-MX") return es_mx2_table_pagination_rowsperpage2(inputs)
	if (locale === "fil") return fil_table_pagination_rowsperpage2(inputs)
	if (locale === "fr") return fr_table_pagination_rowsperpage2(inputs)
	if (locale === "it") return it_table_pagination_rowsperpage2(inputs)
	if (locale === "hu") return hu_table_pagination_rowsperpage2(inputs)
	if (locale === "nl") return nl_table_pagination_rowsperpage2(inputs)
	if (locale === "no") return no_table_pagination_rowsperpage2(inputs)
	if (locale === "pl") return pl_table_pagination_rowsperpage2(inputs)
	if (locale === "pt-BR") return pt_br2_table_pagination_rowsperpage2(inputs)
	if (locale === "pt") return pt_table_pagination_rowsperpage2(inputs)
	if (locale === "ro") return ro_table_pagination_rowsperpage2(inputs)
	if (locale === "fi") return fi_table_pagination_rowsperpage2(inputs)
	if (locale === "sv") return sv_table_pagination_rowsperpage2(inputs)
	if (locale === "vi") return vi_table_pagination_rowsperpage2(inputs)
	if (locale === "tr") return tr_table_pagination_rowsperpage2(inputs)
	if (locale === "cs") return cs_table_pagination_rowsperpage2(inputs)
	if (locale === "bg") return bg_table_pagination_rowsperpage2(inputs)
	if (locale === "ru") return ru_table_pagination_rowsperpage2(inputs)
	if (locale === "uk") return uk_table_pagination_rowsperpage2(inputs)
	if (locale === "ar") return ar_table_pagination_rowsperpage2(inputs)
	if (locale === "hi") return hi_table_pagination_rowsperpage2(inputs)
	if (locale === "th") return th_table_pagination_rowsperpage2(inputs)
	if (locale === "ja") return ja_table_pagination_rowsperpage2(inputs)
	if (locale === "zh-CN") return zh_cn2_table_pagination_rowsperpage2(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_pagination_rowsperpage2(inputs)
	return ko_table_pagination_rowsperpage2(inputs)
});
export { table_pagination_rowsperpage2 as "table.pagination.rowsPerPage" }